import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { dateCompare } from "jsFunctions/dateTimeFormat";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";

const SpentAmountTable = ({ editSpentInfo, currentSpentInfo, type }) => {
    return (

        type === 'current' ?
            <div className="info-table change-modal-table">

                <Table className="table-info">
                    <Thead>
                        <Tr>
                            <Th>Payee</Th>
                            <Th>Bank</Th>
                            <Th>ReferenceNo</Th>

                            <Th>Amount</Th>
                            <Th>Date</Th>

                        </Tr>
                    </Thead>
                    <Tbody>
                        {editSpentInfo.map((item, index) => {
                            return (
                                <Tr>
                                    <Td className={`${item?.pyId?._id !== currentSpentInfo[index]?.pyId?._id ? 'data_compare_red' : ''}`}>{item?.pyId?.val}</Td>
                                    <Td className={`${item?.bnkId?._id !== currentSpentInfo[index]?.bnkId?._id ? 'data_compare_red' : ''}`}>{item?.bnkId?.val}</Td>
                                    <Td className={`${item?.refNo !== currentSpentInfo[index]?.refNo ? 'data_compare_red' : ''}`}>{item?.refNo}</Td>

                                    <Td className={`${item?.amt !== currentSpentInfo[index]?.amt ? 'data_compare_red' : ''}`}>{formatAmountInINR(parseFloat(item?.amt || 0))}</Td>
                                    <Td className={`${!(dateTimeFormat(item?.pmtDt), dateTimeFormat(currentSpentInfo[index]?.pmtDt)) ? 'data_compare_red' : ''}`}>{dateTimeFormat(item?.pmtDt)}</Td>

                                </Tr>

                            );
                        })}
                    </Tbody>
                </Table>
            </div>
            :
            <div className="info-table change-modal-table">

                <Table size="md" className="table-info" w='100'>
                    <Thead>
                        <Tr>
                            <Th>Payee</Th>
                            <Th>Bank</Th>
                            <Th>ReferenceNo</Th>
                            <Th>Amount</Th>
                            <Th>Date</Th>

                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentSpentInfo?.map((item, index) => {
                            return (
                                <Tr>
                                    <Td className={`${item?.pyId?._id !== editSpentInfo[index]?.pyId?._id ? 'data_compare_green' : ''}`}>{item?.pyId?.val}</Td>
                                    <Td className={`${item?.bnkId?._id !== editSpentInfo[index]?.bnkId?._id ? 'data_compare_green' : ''}`}>{item?.bnkId?.val}</Td>
                                    <Td className={`${item?.refNo !== editSpentInfo[index]?.refNo ? 'data_compare_green' : ''}`}>{item?.refNo}</Td>

                                    <Td className={`${item?.amt !== editSpentInfo[index]?.amt ? 'data_compare_green' : ''}`}>{formatAmountInINR(parseFloat(item?.amt || 0))}</Td>
                                    <Td className={`${!dateCompare(dateTimeFormat(item?.pmtDt), dateTimeFormat(editSpentInfo[index]?.pmtDt)) ? 'data_compare_green' : ''}`}>{dateTimeFormat(item?.paymentDate)}</Td>

                                </Tr>

                            );
                        })}
                    </Tbody>
                </Table>
            </div>
    )


}

export default SpentAmountTable;
